import { ProgressBarItem } from 'components/ProgressBar';

export const ITEMS: ProgressBarItem[] = [
  {
    type: 'single',
    title: 'Review Quote',
    active: false,
  },
  {
    type: 'single',
    title: 'Choose Payment',
    active: true,
  },
  {
    type: 'single',
    title: 'Complete',
    active: false,
  },
];
